
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diviner-signup",
      function () {
        return require("private-next-pages/diviner-signup/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/diviner-signup"])
      });
    }
  